import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { SPONSORS, PRESS } from "../../data";

export const Sponsors = () => {
  const { t } = useLang();

  return (
    <section id="sponsors" data-testid="sponsors-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <Reveal>
          <Overline>{t.sponsors.overline}</Overline>
          <h2 className="mt-5 font-serif text-4xl font-medium italic tracking-tight text-ink md:text-5xl">
            {t.sponsors.title}
          </h2>
        </Reveal>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-px">
          {SPONSORS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.06}>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`sponsor-${i}`}
                className="group flex h-44 items-center justify-center border border-ink/10 bg-cream px-16 transition-colors duration-500 hover:bg-parchment md:h-52 md:px-24"
              >
                <img
                  src={s.img}
                  alt={s.name}
                  loading="lazy"
                  className="max-h-24 w-auto max-w-full object-contain transition-transform duration-500 ease-out group-hover:scale-105 md:max-h-28"
                />
              </a>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-24 border-y border-ink/12 py-6" data-testid="press-marquee">
        <p className="mb-5 text-center text-[10px] font-semibold uppercase tracking-[0.34em] text-ink/45">
          {t.sponsors.press}
        </p>
        <Marquee speed={24} gradient={false} pauseOnHover>
          {PRESS.map((p, i) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`press-link-${i}`}
              className="mx-8 flex h-16 items-center md:h-20"
            >
              <img
                src={p.img}
                alt={p.name}
                loading="lazy"
                className="h-9 w-auto max-w-[150px] object-contain opacity-80 transition-opacity duration-300 hover:opacity-100 md:h-11 md:max-w-[180px]"
              />
            </a>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
